import React from 'react';
import cn from 'classnames';
import styles from './AiChatbot.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { adjustActionsPopupStatus, resetUserHistory } from '../../store/actions/aiChatbot';
import { AI_CHATBOT_STATUS } from '../../constants/aiChatbot';
import { isEmpty } from 'lodash';

function AdditionalActionsPopup() {
  const dispatch = useDispatch();
  const { actionsPopupStatus, history } = useSelector((state) => state.aiChatbot);

  const resetButtonClick = () => {
    dispatch(adjustActionsPopupStatus(AI_CHATBOT_STATUS.OFF));
    if (!isEmpty(history)) {
      dispatch(resetUserHistory());
    }
  };

  return (
    <div className={cn(styles.additionalActionMenu, actionsPopupStatus === AI_CHATBOT_STATUS.ON ? styles.open : '')}>
      <div className={styles.customBlock}>
        <section className={styles.buttonContainer}>
          <button onClick={resetButtonClick} className={styles.resetButton}>
            Reset chat
          </button>
        </section>
      </div>
    </div>
  );
}

export default AdditionalActionsPopup;
